import Layout from "@/layout/index.vue";
const newsManager = {
    path: '/toilet',
    component: Layout,
    redirect: 'noRedirect',
    name: 'toiletManager',
    meta: {
        title: '',
        icon: 'DocumentCopy'
    },
    children: [
        {
            path: 'toilet',
            component: () => import('@/views/toilet/index.vue'),
            name: 'toilet',
            meta: { title: '地址管理', noCache: true,icon: 'DocumentCopy'  }
        },
    ]

}

export default newsManager
